module.exports = __webpack_public_path__ + "media/images/icons/users-90efc33f513f2c9b785ce4412cbc917e.svg";